export function isValidUrl(str?: string): str is string {
  if (!str) return false
  try {
    return Boolean(new URL(str))
  } catch (e) {
    return false
  }
}

export function isExternalUrl(url: string): boolean {
  return /^https?:\/\//.test(url)
}

export function slugify(input: string) {
  return (
    input
      .replaceAll(/[^0-9a-zA-Z-\s]/g, '')
      .replaceAll(/\s+/g, '-')
      .replaceAll(/-+/g, '-')
      // 80 is an arbitrary number, but it's a good length for a URL
      .slice(0, 80)
      .replaceAll(/^-|-$/g, '')
  )
}

// `parseArtworkUrl` / `parseModelUrl` previously lived here; they were
// moved to `pixai-utils/url` in main (so the SSR server package can
// share the same parser without depending on `pixai-app`). Import
// them from `pixai-utils/url` everywhere now.
